import React from 'react';

export default function HealthPlusMenuCard({
  isActive = false,
  onClick,
  className = '',
  activeButtonLabel = 'Sağlık+ durdur',
  inactiveButtonLabel = 'Sağlık+ aktivasyonu',
}) {
  return (
    <div className={`rounded-3xl border border-primary/20 bg-primary/5 p-4 shadow-sm ${className}`}>
      <div className="mb-3 flex items-start justify-between gap-2">
        <div>
          <div className="text-[10px] font-black uppercase tracking-widest text-primary">Sağlık+ Premium</div>
          <h3 className="mt-1 text-base font-black text-slate-900 dark:text-slate-100">Mutfakta daha uygun seçimler</h3>
        </div>
        <div className="rounded-full bg-amber-400 px-3 py-1 text-[10px] font-black uppercase tracking-widest text-slate-900 shadow">
          Premium
        </div>
      </div>

      <div className="flex flex-col gap-3">
        {isActive ? (
          <>
            <p className="text-xs text-slate-600 dark:text-slate-300">
              Sağlık+ aktif. Sonuçlar sağlık modlarına göre kişiselleştiriliyor.
            </p>
            <div>
              <button
                onClick={onClick}
                className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-xs font-bold text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
              >
                {activeButtonLabel}
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="text-xs text-slate-600 dark:text-slate-300">
              Aile bireyi, mod ve opsiyonel tahlil bilgisiyle mutfak sıralamasını sana göre optimize eder.
            </p>
            <div>
              <button
                onClick={onClick}
                className="rounded-xl bg-slate-900 px-4 py-2 text-xs font-black text-white dark:bg-white dark:text-slate-900"
              >
                {inactiveButtonLabel}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
